export function getPayorsCount(payors) {
  if (payors.length === 0) return ''

  let payor_name
  if (payors[0].payment_account.account_type === 'PersonPaymentAccount') {
    payor_name =
      payors[0].payment_account.person_payment_account.payer_person.first_name.toUpperCase()
  } else {
    payor_name =
      payors[0].payment_account.insurance_payment_account.insurance_company.carrier_name.toUpperCase()
  }

  return payors.length === 1
    ? payor_name
    : `${payor_name} +${payors.length - 1}`
}
